module.exports = __webpack_public_path__ + "static/background2-7067e87e5bb43d245083b3d472db035d.jpg";